<template>
  <div v-if="$route.name === 'Orders'" class="animated fadeIn">
    <order-top-panel></order-top-panel>
    <loading v-if="loading" message="Загружаем заказы..."></loading>
    <div v-else class="card" v-for="date in ordersDays">
      <div class="card-header">
        {{convertDataToString(date)}}
        <div class="pull-right">
          Заказов отмено: {{getOrdersCanceledByDate(date).length}}
          <button class="ml-2 btn btn-sm btn-secondary" v-if="showCanceled" @click.prevent="showCanceled = false">Скрыть отмененые</button>
          <button class="ml-2 btn btn-sm btn-danger" v-else  @click.prevent="showCanceled = true">Показать отмененые</button>
        </div>
      </div>
      <div class="card-block orders-items">
        <div class="row" style="margin-left: -20px; margin-right: -20px">
          <div class="col-12 mt-1 mb-1 small  hidden-md-down">
            <div class="row">
              <div class="col-1">
                <div class="row">
                  <div class="col-12 col-lg-7">№</div>
                  <div class="col-12 col-lg-5">Время</div>
                </div>
              </div>
              <div class="col-3 col-lg-2">Статус</div>
              <div class="col-2 col-lg-3">Описание</div>
              <div class="col-2">Клиент</div>
              <div class="col-2">Город, компания, техцентр</div>
              <div class="col-1" style="word-wrap: break-word"> </div>
              <div class="col-1">Действие</div>
            </div>
          </div>
          <div
                  v-for="(order, index) in getOrdersByDate(date)"
                  :key="order.id"
                  class="col-12 order-item"
                  :id="getIdElement(order.id)"
                  :class="{ active: activeOrderId === order.id, 'text-danger': order.problem && !order.canceled, 'text-muted': order.canceled}"
          >
            <div class="row order-item-row"
                 @click.prevent="showOrderDetail(order.id)"
                 :class="{
                  active: activeOrderId === order.id,
                  'order-item-row--commission-problem': getCommission(order.sum, order.profit) !== false && getCommission(order.sum, order.profit) < 10
                  }">
              <div class="col-6 col-md-1">
                <div class="row">
                  <div class="col-12 col-lg-7">
                    <small class="hidden-md-up text-muted">№ <br></small>
                    {{order.id}}
                    <br><span class="text-muted small">{{order.amoId}}</span>
                    <a :href="getAmoLeadUrl(order.amoId)"
                       target="_blank"
                       class="btn btn-secondary btn-sm"
                       v-if="order.amoId"
                       @click.stop
                    >Открыть<br> в AmoCRM</a>
                  </div>
                  <div class="col-12 col-lg-5">
                    <small class="hidden-md-up text-muted">Время <br></small>
                    {{order.time}}
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2">
                  <order-status :order="order" :commission="getCommission(order.sum, order.profit)"></order-status>
              </div>
              <div class="col-6 col-md-5 col-lg-3">
                {{order.description}}
                <div class="text-danger small" v-if="order.canceled">
                  Причина отмены: {{order.cancelCause}}.
                  <span v-if="order.movedOrder">
                    <a href="#" @click.stop.prevent="showMovedOrderDetail(order.movedOrder.id)">Заказ №{{order.movedOrder.id}}</a> в <span class="badge" :style="{ backgroundColor: order.movedOrder.techcenter.color }">{{order.movedOrder.techcenter.address}}</span>
                  </span>
                </div>
                <div class="text-danger small" v-if="order.problem"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Проблема с заказом: {{order.problemCause}}</div>
              </div>
              <div class="col-6 col-md-3 col-lg-2">
                <order-client-info :order="order"></order-client-info>
              </div>
              <div class="col-6 col-md-9 col-lg-2">
                <order-techcenter-info :order="order"></order-techcenter-info>
              </div>
              <div class="col-1">
                 <span v-b-tooltip placement="bottom" :title="getCreatedDescr(order)">
                  <i class="fa fa-clock-o"></i>
                </span>
                <span v-b-tooltip placement="bottom" :title="getCommentsDescr(order.commentsCountUnviewed)">
                  <span class="text-muted" :class="{ 'text-warning': order.commentsCountUnviewed }"><i class="fa fa-comment-o"></i></span>
                  {{order.commentsCount}}
                </span>
              </div>
              <div class="col-1">
                <order-actions :order="order"></order-actions>
              </div>
            </div>
            <div class="row mt-2" v-if="activeOrderId === order.id">
              <hr>
              <div class="col-12 col-lg-6">
                <comments :order="order"></comments>
              </div>
              <div class="col-12 col-lg-6">
                <b-card>
                  <b-tabs ref="tabs" card :lazy="true">
                    <b-tab title="<i class='fa fa-history'></i> История изменений заказа" active>
                      <order-history :order="order"></order-history>
                    </b-tab>
                    <b-tab v-if="order.canViewCallHistory" title="<i class='fa fa-phone'></i> История звонков">
                      <order-call-history :order="order"></order-call-history>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showAlertNoOrders" class="alert alert-warning">
      <h6>К сожалению заказы по заданным параметрам не найдены. Попробуйте изменить параметры поиска или режим отображения заказов.</h6>
    </div>
  </div>
  <router-view v-else/>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  import OrderStatus from './OrderStatus.vue'
  import OrderTopPanel from './OrderTopPanel.vue'
  import OrderActions from './OrderActions.vue'
  import OrderClientInfo from './OrderClientInfo.vue'
  import OrderTechcenterInfo from './OrderTechcenterInfo.vue'
  import Comments from './../../components/Comments.vue'
  import OrderHistory from './OrderHistory.vue'
  import OrderCallHistory from './OrderCallHistory.vue'
  export default {
    computed: {
      showAlertNoOrders () {
        return this.orders.length === 0 && !this.loading
      },
      ordersDays () {
        return this.orders.map(function (item) {
          return item.date
        }).filter(function (value, index, self) {
          return self.indexOf(value) === index
        }).sort(function (a, b) {
          let dateA = moment(a, 'DD.MM.YYYY')
          let dateB = moment(b, 'DD.MM.YYYY')
          return dateB.isBefore(dateA) ? 1 : -1
        })
      },
      ...mapState({
        orders: state => state.orderStore.orders,
        currentUser: state => state.globalStore.user,
        loading: state => state.orderStore.loading,
        activeOrderId: state => state.orderStore.activeOrderId
      })
    },
    name: 'Orders',
    data () {
      return {
        showCanceled: true
      }
    },
    methods: {
      getCommission (sum, profit) {
        if (sum !== null && profit !== null && this.userCanSeeCommission()) {
          return parseInt((profit / sum) * 100)
        }
        return -1
      },
      userCanSeeCommission () {
        return this.currentUser || (this.currentUser.hasPermission('order.finance.all') ||
          this.currentUser.hasPermission('order.finance.companies') ||
          this.currentUser.hasPermission('order.finance.techcenters') ||
          this.currentUser.hasPermission('order.finance.his'))
      },
      getOrdersByDate (date) {
        return this.orders.filter((order) => {
          if (this.showCanceled) {
            return order.date === date
          } else {
            return order.date === date && !order.canceled
          }
        }).sort(function (a, b) {
          if (a.time > b.time) {
            return 1
          } else if (a.time < b.time) {
            return -1
          } else if (a.id > b.id) {
            return 1
          } else if (a.id < b.id) {
            return -1
          } else {
            console.error('error')
            return 0
          }
        })
      },
      getOrdersCanceledByDate (date) {
        return this.orders.filter(function (order) {
          return order.date === date && order.canceled
        })
      },
      convertDataToString (date) {
        moment.locale('ru')
        let dateString = moment(date, 'DD.MM.YYYY').format('dddd D MMMM Y').toString()
        dateString = dateString.charAt(0).toUpperCase() + dateString.substr(1)
        return dateString
      },
      showOrderDetail (id) {
        // if (this.activeOrderId !== id) {
        //   this.$store.dispatch('setActiveOrderId', id)
        //   this.$scrollTo('#order_' + id, 500, {
        //     offset: -50
        //   })
        // } else {
        //   this.$store.dispatch('setActiveOrderId', null)
        // }
        this.$store.dispatch('setActiveOrderId', null)
        this.$router.push({ name: 'Order', params: { id: id } })
      },
      getIdElement (id) {
        return 'order_' + id
      },
      getCommentsDescr (count) {
        if (count) {
          return 'Непрочитанных комментариев: ' + count
        } else {
          return 'Непрочитанных комментариев нет'
        }
      },
      getCreatedDescr (order) {
        let text = 'Заказ был добавлен ' + order.date
        if (order.closed) {
          text += ' и закрыт ' + order.closed
        }
        return text
      },
      showMovedOrderDetail (id) {
        this.$store.dispatch('showOrderDetail', id)
      },
      getAmoLeadUrl (id) {
        return 'https://alarmru.amocrm.ru/leads/detail/' + id
      }
    },
    components: {
      OrderStatus,
      OrderTopPanel,
      OrderActions,
      Comments,
      OrderHistory,
      OrderCallHistory,
      OrderClientInfo,
      OrderTechcenterInfo
    }
  }
</script>
<style lang="scss" scoped>
  .orders-items{
    padding-top: 0;
    padding-bottom: 0;
  }
  @media screen and (max-width: 960px) {
    .order-item{
      border-bottom: 1px solid #e4e6eb;
    }
    .order-item:last-child {
      border-bottom: none;
    }
  }

  .order-item-row{
    padding-top: 10px;
    padding-bottom: 10px;

    &:hover {
      background: #f5f5f5;
    }

    &--commission-problem {
      border-left: 5px solid #aa0600;

      &:hover {
        border-left-color: #e00600;
      }
    }
  }

  .order-item-row {
    cursor: pointer;
  }
  .order-item.active{
    background: #f5f5f5;
  }
</style>



// WEBPACK FOOTER //
// List.vue?20133759